module.exports = __webpack_public_path__ + "img/3화_2_수정(1).1951d386.jpg";